// import * as R from "ramda"
import React from "react"

import { withRouter } from "react-router-dom"
import qs from "query-string"
import I18nProvider from "i18n"

function setBodyAttrs(lang = "en") {
  document.body.setAttribute("lang", lang)
  document.body.setAttribute("dir", lang === "ar" ? "rtl" : "ltr")
}

const initialContextShape = {
  userId: undefined,
  email: undefined,
  contact: undefined,
  lang: "en",
}

export const SharedContext = React.createContext(initialContextShape)

export function useSharedContext() {
  const c = React.useContext(SharedContext)
  return c
}

function Shared(props) {
  const {
    location: { search },
  } = props

  const [state, setState] = React.useState(() => initialContextShape)

  // In case any of the parent params change,
  // the iframe window will be reloaded.
  // We only need to run this effect once
  React.useEffect(() => {
    let _search = search
    if (!search && process.env.NODE_ENV === "development") {
      _search = "?userId=12345qwert&email=arthur.shelby@pb.com"
    }
    const q = qs.parse(_search)
    const info = {
      userId: q.userId || "",
      email: q.email || "",
      contact: q.contact || q.email || "",
      lang: (q.lang || "en").toUpperCase(),
    }

    setState(info)
    //eslint-disable-next-line
  }, [])

  const contextValue = state

  const lowerLang = contextValue.lang.toLowerCase()
  React.useEffect(() => {
    setBodyAttrs(lowerLang)
  }, [lowerLang])

  return (
    <SharedContext.Provider value={contextValue}>
      <I18nProvider lang={lowerLang}>{props.children}</I18nProvider>
    </SharedContext.Provider>
  )
}

export default withRouter(Shared)
